export const DELETE_ERROR_MSG = "DELETE_ERROR_MSG";

export default function deleteErrorMessage(key) {
  return {
    type: DELETE_ERROR_MSG,
    payload: { key },
  };
}
